import(/* webpackMode: "eager" */ "/codebuild/output/src916688651/src/pubgen-app/next-app/app/global-error.tsx");
